<template>
  <div class="stock-feed-view">
    <el-row type="flex" justify="end">
      <div style="display:flex">
        <er-input
          inputType="search"
          v-model="filters[0].value"
          size="mini"
          suffix-icon="el-icon-search"
          :placeholder="$t('Comn_search')"
        ></er-input>

        <er-action-button
          @action-btn-click="handleClickAction()"
          :type="'solid'"
          :disabled="isReadOnly"
        >
          <template v-slot:icon>
            <img style="margin-top: 4px;" src="@/assets/button/add.svg" />
          </template>
          <template v-slot:label>
            <p style="text-transform: uppercase;">{{ $t("Stock_add_feed") }}</p>
          </template>
        </er-action-button>
      </div>
    </el-row>

    <div>
      <component
        :is="`feedAddDialog`"
        :show-dialog="dialogVisible"
        @close_dialog="closeDialog"
      ></component>

      <feed-table></feed-table>
    </div>

    <div class="bottom-container">
      <p v-html="$t('Medicines_abbr')"></p>
    </div>
  </div>
</template>

<script>
import feedActionBar from "@/components/stock/feedActionBar";
import feedTable from "@/components/stock/feedTable";
import feedAddDialog from "@/components/stock/feedAddDialog";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { feedActionBar, feedTable, feedAddDialog },
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      loading: false,
      dialogVisible: false,
      filters: [
        {
          value: "",
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (["feed_name"].indexOf(prop) > -1) {
                return row[prop]
                  .toLowerCase()
                  .includes(filter.value.toLowerCase());
              }
            });
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", {
      getCurrUserLocation: "getCurrUserLocation"
    }),
    location: function() {
      return this.getCurrUserLocation;
    }
  },
  async mounted() {
    await this.initComponent();
  },
  methods: {
    ...mapActions("resource", {
      fetchAllResources: "fetchAllResources",
      fetchAllVendors: "fetchAllVendors"
    }),
    async initComponent() {
      try {
        this.loading = true;
        await this.fetchAllResources({ type: "FEED" });
        await this.fetchAllVendors();
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    handleClickAction() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss">
.stock-feed-view {
  .bottom-container {
    opacity: 0.4;
    font-weight: bold;
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2
    );
  }
  .input--search {
    padding: 0px;
    margin-right: 10px;
  }
}
</style>
